import { useSelector } from "react-redux";
import ReactHtmlParser from "react-html-parser";

import Accordion from "@stadium/ui/src/components/accordion/accordion";
import BoxItemsInfo from "@components/store/product-detail/shared/accordion/box-items-info";

import useWithAnalytics from "@stadium/services/analytics/hooks/use-with-analytics";
import { useCreateSwagContext } from "@contexts/create-swag-context";

import { getIsLockerShop } from "@selectors/store";
import { ANALYTICS_TARGET_DESCRIPTION_INFO } from "@constants/analytics/shop";

import styles from "./main.module.scss";

const ProductDescriptionAccordion = ({ product, variantSelected = {} }) => {
  const isLockerShop = useSelector(getIsLockerShop);

  const { isSwagCreationShopFlow } = useCreateSwagContext();

  const withAnalytics = useWithAnalytics();

  const { description: productDescription, validPrintTypes } = product;

  const description = variantSelected?.description || productDescription;

  const showDecorationMethods = isLockerShop && validPrintTypes?.length > 0;

  const renderDescription = () => {
    if (!description) return null;
    return (
      <Accordion
        id="product-information"
        customClass={styles.panelGroup}
        onClick={() => {
          withAnalytics(undefined, {
            target: ANALYTICS_TARGET_DESCRIPTION_INFO,
            track: true,
            eventProperties: {
              product_id: product.id,
            },
          })();
        }}
        titleContent={
          <div className={styles.acord}>
            <div className={styles.primaryColor}>Product Information</div>
            <div className={`${styles.iconChevronUp} collapseicon`}></div>
          </div>
        }
      >
        <div className={styles.panelBodyInfo}>{ReactHtmlParser(description)}</div>
        <BoxItemsInfo intent={product?.intent} />
      </Accordion>
    );
  };

  const renderDecorationMethods = () => {
    if (!showDecorationMethods) return null;
    return (
      <Accordion
        id="decoration-methods"
        customClass={styles.panelGroup}
        titleContent={
          <div className={styles.acord}>
            <div className={styles.primaryColor}>Decoration Method</div>
            <div className={`${styles.iconChevronUp} collapseicon`}></div>
          </div>
        }
      >
        <div className={styles.decorationContainer}>
          {validPrintTypes?.map(({ name }) => name).join(", ")}
        </div>
      </Accordion>
    );
  };

  return (
    <div
      className={`${styles.sharedDescriptionWithFlag} ${isSwagCreationShopFlow ? styles.swagProductDescription : ""}`}
      data-group="accordion"
      tabIndex={0}
    >
      {renderDescription()}
      {renderDecorationMethods()}
    </div>
  );
};

export default ProductDescriptionAccordion;
